import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { deepMerge } from "@utils/deepMerge";
import enLocal from "@i18n/locales/en/translation.json";
import urLocal from "@i18n/locales/ur/translation.json";
import { enTranslations, urTranslations } from "@tvet-mis/psda-assets";

const mergedEn = deepMerge({}, enTranslations, enLocal);
const mergedUr = deepMerge({}, urTranslations, urLocal);

// Get saved language preference from localStorage
const savedLanguage = localStorage.getItem("preferredLanguage") || "en";

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: mergedEn },
		ur: { translation: mergedUr },
	},
	lng: savedLanguage,
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
	react: {
		useSuspense: true,
	},
});

export default i18n;
